/* Product template "look-a" (knowledge/tech/product-template-a.md): scroll reveal + "+ Add" of the add-ons box.
   Loaded by sections/chumzy-look-marquee.liquid (always) and chumzy-look-addons.liquid; the guard makes a second load harmless. */
(() => {
  if (window.__czLook) return;
  window.__czLook = true;

  const still = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    const els = (root || document).querySelectorAll('.cz-rv:not(.is-in)');
    if (still() || !('IntersectionObserver' in window)) {
      els.forEach((e) => e.classList.add('is-in'));
      return;
    }
    document.body.classList.add('cz-rv-ready');
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }), { threshold: 0.15 });
    els.forEach((e) => io.observe(e));
  }

  const drawerEl = () => document.querySelector('cart-drawer');

  async function addOne(id, button) {
    const msg = button.closest('.cz-look-add').querySelector('[data-cz-add-msg]');
    const show = (text) => { msg.textContent = text; msg.hidden = !text; };
    const body = { items: [{ id: Number(id), quantity: 1 }] };
    const drawer = drawerEl();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    show('');
    button.disabled = true;
    try {
      const res = await fetch(`${(window.routes && routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) {
        show(data.description || data.message || 'Sorry, we could not add that.');
        return;
      }
      if (drawer && data.sections) {
        drawer.renderContents(data);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'chumzy-look-addons' });
        }
      } else {
        window.location.href = (window.routes && routes.cart_url) || '/cart';
      }
    } catch (err) {
      show('Sorry, we could not add that.');
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest && ev.target.closest('[data-cz-add]');
    if (btn) addOne(btn.dataset.czAdd, btn);
  });

  reveal();
  document.addEventListener('shopify:section:load', (ev) => reveal(ev.target));
})();
